export const languageCode = 'pt';
export const languageLabel = 'Portuguese';

export const translations = {
  AUDIO_DESCRIPTION_OFF: 'Desligado',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: 'Ocultar menu de legendas',
  CAPTIONS_OFF: 'Desligado',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: 'Procurar Vídeo',
  CAPTIONS_SHOW_MENU: 'Mostrar menu de legendas',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: 'Fechar capítulos',
  CHAPTERS_OPEN_CHAPTERS: 'Abrir capítulos',

  CLICK_FOR_SOUND_DESKTOP_TEXT: 'Clique para ativar o som',
  CLICK_FOR_SOUND_MOBILE_TEXT: 'Toque para ativar o som',

  CONTEXT_MENU_ABOUT_WISTIA: 'Sobre a Wistia',
  CONTEXT_MENU_COPIED: 'Cópia efetuada!',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: 'Copiar ligação e miniatura',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'Sessão iniciada em Wistia',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Abrir vídeo em Wistia',
  CONTEXT_MENU_REPORT_A_PROBLEM: 'Reportar um problema',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'Ver estatísticas em Wistia',

  CUSTOMER_LOGO_LOGO: 'Logótipo',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: 'Sair de ecrã inteiro',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: 'Ecrã inteiro',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: 'Vídeo',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: 'Reproduzir',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: 'Pausa',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: 'Adicione detalhes',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: 'Escolha uma opção',
  REPORT_A_PROBLEM_DESCRIPTION:
    'Obrigado por reportar um problema. Iremos anexar dados técnicos desta sessão para resolvermos o problema. Qual das situações abaixo descreve melhor o problema?',
  REPORT_A_PROBLEM_DISMISS: 'Dispensar',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: 'Não é possível reproduzir o vídeo',
  REPORT_A_PROBLEM_OTHER: 'Outro',
  REPORT_A_PROBLEM_OTHER_CONTEXT: 'Pode indicar mais detalhes ou contexto?',
  REPORT_A_PROBLEM_POOR_QUALITY: 'A qualidade do vídeo é fraca',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: 'Categoria do problema',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: 'Descrição do problema',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: 'Selecione uma categoria',
  REPORT_A_PROBLEM_SEND: 'Enviar',
  REPORT_A_PROBLEM_SENDING: 'A enviar...',
  REPORT_A_PROBLEM_STUTTER: 'O vídeo é reproduzido, mas tem muitas paragens',

  REWATCH: 'Ver novamente',

  SETTINGS_PLAYBACK_RATE_TITLE: 'Velocidade',
  SETTINGS_QUALITY_AUTO: 'Auto',
  SETTINGS_QUALITY_TITLE: 'Qualidade',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: 'Fechar menu partilhar',
  SHARE_CONTROL_OPEN: 'Abrir menu partilhar',
  SHARE_COPIED: 'Cópia efetuada!',
  SHARE_DOWNLOAD: 'Transferir',
  SHARE_EMAIL: 'E-mail',
  SHARE_EMBED: 'Incorporar',
  SHARE_FACEBOOK: 'Facebook',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',

  SKIP: 'Ignorar',

  STATUS_BAR_EMBED_CODE_COPIED:
    'O Código Incorporado foi copiado para a sua área de transferência!',

  THUMBNAIL_VIDEO_THUMBNAIL: 'Miniatura de vídeo',

  TURNSTILE_DEFAULT_END: 'Obrigado por assistir! \nIndique o seu endereço de e-mail.',
  TURNSTILE_DEFAULT_START: 'Indique o seu endereço de e-mail para assistir a este vídeo.',
  TURNSTILE_EMAIL_PLACEHOLDER: 'O seu e-mail',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: 'Primeiro nome',
  TURNSTILE_LAST_NAME_PLACEHOLDER: 'Sobrenome',
  TURNSTILE_PLAY: 'Reproduzir',
  TURNSTILE_SUBMIT: 'Submeter',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: 'Barra de Volume',
  VOLUME_TITLE_WHEN_MUTED: 'Com som',
  VOLUME_TITLE_WHEN_UNMUTED: 'Sem som',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'O vídeo seguinte será reproduzido em...',
};
